import { IconButton, InputAdornment, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';
import Iconify from '../../../../../../reusable-components/iconify/Iconify';
import { formStyle } from '../../../contractStyles';

TextInput.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default function TextInput({ fieldName, focusedField, setFocusedField, disabled, placeholder = '' }) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ name: fieldName, control });

  return (
    <TextField
      inputRef={field.ref}
      key={field.id}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
      onFocus={() => setFocusedField?.(fieldName)}
      inputProps={{
        onBlur: () => setFocusedField?.(null),
      }}
      placeholder={placeholder}
      autoComplete="off"
      fullWidth
      size="small"
      type="text"
      disabled={disabled}
      value={field.value ?? ''}
      error={!!fieldState.error}
      onChange={(e) => field.onChange(e.target.value)}
      helperText={fieldState.error?.message}
      sx={formStyle}
      InputProps={{
        sx: { background: 'white' },
        endAdornment:
          field.value && focusedField === fieldName ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onMouseDown={(e) => {
                  e.preventDefault();
                  field.onChange('');
                }}
                edge="end"
                tabIndex={-1}
              >
                <Iconify icon="eva:close-outline" />
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
    />
  );
}
